module.exports = __webpack_public_path__ + "media/images/pic/testimonials/gabrysia-49c47b8430a32c21c21ef23515408948.jpg";